/**
 * Resolve a company branding setting with optional per-language overrides.
 * Tries `{baseKey}.{languageCode}`, then `{baseKey}.en`, then `{baseKey}`.
 */
export function getLocalizedBrandingSetting(settings, baseKey, languageCode) {
    if (!settings) return undefined;

    const localized = settings[`${baseKey}.${languageCode}`];
    if (localized) return localized;

    const english = settings[`${baseKey}.en`];
    if (english) return english;

    return settings[baseKey];
}

export function interpolateBrandingText(text, variables = {}) {
    if (!text) return text;
    return text.replace(/\{\{(\w+)\}\}/g, (match, key) => {
        const value = variables[key];
        if (value !== undefined && value !== null) {
            return String(value);
        }
        return match;
    });
}
